import axios from 'axios';

export async function TokenRefreshedInterceptor(error: any): Promise<any> {
    if (error.response && error.response.status === 440) {
        if (error.config && !error.config._isRetryRequest) {
            error.config.__isRetryRequest = true;
            return axios(error.config);
        }
    }

    return error;
}
